/** @jsxImportSource @emotion/react */
import { StepperMainTool, type StepsPath } from 'modules/main/domain/utils/stepper-tool';
import React, { useLayoutEffect, useState } from 'react';
import type { DivProps } from 'typings';
import { ClickableArea } from 'ud-ui/components';
import RhombusIcon from 'ud-ui/components/icon/rhombus-icon';
import UDLink from 'ud-ui/components/link';
import Text from 'ud-ui/components/text';
import * as S from './styles';

export interface IStepProps extends DivProps {
  emoji: string | React.ReactNode;
  header: string;
  action: 'Создать' | 'Добавить' | 'Заявить' | 'Запустить' | 'Начать';
  to: string;
  checkProperty?: StepsPath;
}

function Step(props: IStepProps) {
  const { ...rest } = props;
  const [isComplete, setComplete] = useState(false);

  useLayoutEffect(() => {
    if (props.checkProperty) {
      setComplete(StepperMainTool.getByPath(props.checkProperty));
    }
  }, [props.checkProperty]);

  return (
    <S.MainBlock {...rest}>
      <S.EmojiBlock>{props.emoji}</S.EmojiBlock>
      <RhombusIcon isComplete={isComplete} />
      <Text variant="subtitle-1" center>
        {props.header}
      </Text>
      <UDLink to={props.to} className="typo subtitle-1-bold active">
        <ClickableArea horizontalExtend={20} verticalExtend={20}>
          {props.action}
        </ClickableArea>
      </UDLink>
    </S.MainBlock>
  );
}

export default Step;
